import { useCallback, useEffect, useState } from 'react';
import { fetchHiredApplicants } from '../../../services/api';

const useHiredApplicants = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchHiredApplicants();
      setGroups(Array.isArray(data) ? data.filter(Boolean) : []);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { groups, loading, error, reload };
};

export default useHiredApplicants;
